import { createContext } from 'react'

import { BusinessAccountForm, BusinessAccountFormContextType } from './types'

export const FormContext = createContext<BusinessAccountFormContextType>(null)

export const initLocalForm: BusinessAccountForm = {
	details: {
		id: '-1',
		reference_id: '',
		name: '',
		startDate: '',
		status: 'ACTIVE',
	},
	notes: {
		content: '',
	},
}
